import React, { Component } from 'react';
import { connect } from 'react-redux';
import Button from 'screens/components/basic/Button';
import TextInput from 'screens/components/basic/TextInput';
import DialogInput from 'screens/components/advanced/DialogInput';
import { initializeLoginForm, clearForgotPassword } from 'actions/FormActions';
import { showError, showSnackbar } from 'actions/CommonActions';
import { login, forgetPassword, getUserRolePageByName } from 'actions/EntityActions';
import { selectLoginModel } from 'selectors/entitySelector';
import LOOKUP from 'constants/lookup';
import ClockInOutPage from './ClockInOutPage';
import DialogHeader from 'screens/components/basic/DialogHeader'
import WithRouter from 'custom/withRouter';

class LoginDialog extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            forgetPassword: false,
            showClockIn: false,
        };
        if (props.tokenExpire) {
            this.props.showError(LOOKUP.authentication.unauthorizedMessage);
        }

        this.cancelClockIn = this.cancelClockIn.bind(this);
    }

    componentWillMount() {
        if (!this.props.unauthorizedUser) {
            this.props.init();
        }  
    }

    componentDidMount() {
        if (this.props.unauthorizedUser) {
            this.removeStoreInformation();
        }
    }

    componentWillReceiveProps(newProps) {
        // const url = window.location.href;
        // if (url.indexOf('clock-in') !== -1) {
        //     this.props.navigate("/clock-in");
        // }

        if (newProps.applicationSetting === null && newProps.branchId !== null) {
            this.props.getApplicationSetting(newProps.branchId);
        }

        if (newProps.forgetPasswordSaveTimeStamp && this.props.forgetPasswordSaveTimeStamp !== newProps.forgetPasswordSaveTimeStamp) {
            if (newProps.forgetPasswordSuccess === true) {
                this.forgotPasswordSuccess();
            }
            else if (this.props.username == "") {
                this.forgotPasswordNullUsername();
            } else if (newProps.forgetPasswordSuccess === false) {
                this.forgotPasswordFailure();
            }
        }

        if (this.props.loginSuccess !== newProps.loginSuccess && newProps.loginSuccess === true) {
            this.props.navigate("/storeList");
        }

        if ((this.props.isUserAuthenticated !== undefined && this.props.isUserAuthenticated !== null && this.props.isUserAuthenticated === false)
            !== (newProps.isUserAuthenticated !== undefined && newProps.isUserAuthenticated !== null && newProps.isUserAuthenticated === false)) {
   
            const isLoggedOut = newProps.isUserAuthenticated === false;
            if (isLoggedOut) {
                this.removeStoreInformation();
                this.props.navigate("/");
            }
        }
    }

    login = () => {
        localStorage.setItem("TECHPOS_PastDueDialog", "");
        this.props.login(this.props.loginModel);
    }

    forgotPasswordSuccess = () => {
        this.props.showSnackbar(LOOKUP.authentication.forgotPasswordSuccessMessage);
        this.cancelForgetPassword();
        this.props.clearForgotPassword();
    }

    forgotPasswordFailure = () => {
        this.props.showError(LOOKUP.authentication.forgotPasswordErrorMessage);
    }

    forgetPassword = () => {
        this.props.forgetPassword(this.props.loginModel.userName);
    }

    // forgot password - when the username is empty
    forgotPasswordNullUsername = () => {
        this.props.showError(LOOKUP.authentication.forgotPasswordNullUsername);
    }

    showForgetPassword = () => {
        this.setState({ forgetPassword: true });
    }

    cancelForgetPassword = () => {
        this.setState({ forgetPassword: false });
    }

    cancelClockIn = () => {
        this.setState({ showClockIn: false })
    }

    onKeyPress = (e) => {
        if (e.key === 'Enter') {
            e.target.blur();
            this.props.login(this.props.loginModel);
        }
    }

    redirectToClockIn = () => {
        this.setState({
            forgetPassword: false,
            showClockIn: true
        });

    }

    removeStoreInformation = () => {
        localStorage.removeItem('TECHPOS_CompanyCode');
        localStorage.removeItem('TECHPOS_ApiUrl');
    }

    render() {
        const p = this.props;
        const forgetPassword = this.state.forgetPassword;
        const url = window.location.href;
        const modalOpen = (url.indexOf('clock-in') === -1) && this.props.isUserAuthenticated !== undefined && this.props.isUserAuthenticated !== null && this.props.isUserAuthenticated === false;

        return (
            this.state.showClockIn ?
                <ClockInOutPage cancel={this.cancelClockIn} />
                :
                <DialogInput
                    title={<div className="modal-title noPadding mb-2">
                        <DialogHeader text="TECHPOS LOGIN" classicClass="posDialogClassic large-dialog-title" />
                    </div>}
                    modal={true}
                    open={modalOpen}
                    style={{ width: '50%' }}
                    className={'loginModal'}

                    autoScrollBodyContent={false}>
                    <form>
                        <div className="form-group">
                            {
                                forgetPassword === false ? (
                                    <div>
                                        <div className="row">
                                            <div className="col-md-8 login-main">
                                                <TextInput name="userName" hintText="Username" fullWidth={true} autoComplete="off" InputLabelProps={{
                                                    // shrink: value !== '',
                                                }} />
                                                <TextInput name="password" onKeyPress={this.onKeyPress} hintText="Password" fullWidth={true} type="password" maxLength={20} autoComplete="off" />
                                                <Button name="btnLogin" label="Login" style={{ width: "100%" }} className="rounded-btn btnNewBrandPOS" primary onTouchTap={() => this.login()} />
                                            </div> {/* .col-md-7 */}
                                            <div className="col-md-4 login-act-group">
                                                <Button label="Forgot Password" style={{ width: "100%" }} secondary onTouchTap={() => this.showForgetPassword()} />
                                                <Button label="Clock In / Out" style={{ width: "100%" }} secondary onTouchTap={() => this.redirectToClockIn()} disabled={true} />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <br />
                                            {
                                                (p.loginSuccess === false && p.loginErrorTimeStamp !== undefined && p.loginErrorTimeStamp !== null)
                                                    ?
                                                    (p.username == "" || p.password == "")
                                                        ?
                                                        (
                                                            <div className="text-center">
                                                                <p className="login-error-msg">
                                                                    <i className="fa fa-exclamation-circle" aria-hidden="true" />
                                                                    Please fill the username or password
                                                                </p>
                                                            </div>
                                                        ) :
                                                        (
                                                            <div className="text-center">
                                                                <p className="login-error-msg">
                                                                    <i className="fa fa-exclamation-circle" aria-hidden="true" />
                                                                    {p.loginError || "Sorry, this username or password isn't correct"}
                                                                </p>
                                                            </div>
                                                        ) : null
                                            }
                                        </div>
                                    </div>
                                ) : (
                                    <div>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <TextInput name="userName" hintText="Username" fullWidth={true} />
                                            </div>
                                        </div>
                                        <div className="row text-center">
                                            <div className="col-md-12">
                                                <p>A new password will be sent to you.</p>
                                                <p>Please ensure the provided email or username is correct.</p>
                                            </div>
                                        </div>
                                        <div className="row text-center">
                                            <div className="col-md-6">
                                                <Button style={{ width: "90%" }} secondary onTouchTap={() => this.cancelForgetPassword()} >Cancel</Button>
                                            </div>
                                            <div className="col-md-6">
                                                <Button style={{ width: "90%" }} primary onTouchTap={() => this.forgetPassword()} >Confirm</Button>
                                            </div>
                                        </div>
                                    </div>
                                )
                            }
                        </div>
                    </form>
                </DialogInput >
        );
    }
}

function mapStateToProps(state) {
    return {
        loginModel: selectLoginModel(state),
        loginSuccess: state.common.loginSuccess,
        isUserAuthenticated: state.common.isUserAuthenticated,
        authUser: state.common.authenticatedUser,
        unauthorizedUser: state.common.unauthorizedUser,
        loginError: state.common.loginError,
        loginErrorTimeStamp: state.common.loginErrorTimeStamp,
        forgetPasswordSuccess: state.form.forgetPasswordSuccess,
        forgetPasswordSaveTimeStamp: state.form.forgetPasswordSaveTimeStamp,
        applicationSetting: state.common.applicationSettings,
        username: state.form.userName,
        password: state.form.password
    };
}

function mapDispatchToProps(dispatch) {
    return {
        init: () => dispatch(initializeLoginForm()),
        login: (model) => dispatch(login(model)),
        showError: (message) => dispatch(showError(message)),
        showSnackbar: (message) => dispatch(showSnackbar(message)),
        forgetPassword: (username) => dispatch(forgetPassword(username)),
        clearForgotPassword: () => dispatch(clearForgotPassword()),
        getUserRolePageByName: (roleName) => dispatch(getUserRolePageByName(roleName))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(LoginDialog));